module.exports = __webpack_public_path__ + "img/8.dff33199.png";